// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BY_CREATION_TIME_NEWEST = "Pridan\u00e9: ned\u00e1vno";
export const BY_CREATION_TIME_OLDEST = "Pridan\u00e9: d\u00e1vno";
export const BY_NEW_MESSAGES = "Pod\u013ea najnov\u0161\u00edch spr\u00e1v";
export const BY_PRICE_ASC = "Cena: najlacnej\u0161ie";
export const BY_PRICE_DESC = "Cena: najdrah\u0161ie";
export const BY_REPOST_TIME_NEWEST = "Aktualizovan\u00e9: ned\u00e1vno";
export const BY_REPOST_TIME_OLDEST = "Aktualizovan\u00e9: d\u00e1vno";
export const BY_TITLE = "Abecedne: A-Z";
export const BY_TITLE_REVERSED = "Abecedne: Z-A";
export const BZ2_CAT_ADULT_FANCY_DRESS = "Oble\u010denie a doplnky na karneval";
export const BZ2_CAT_ADULTS_AUDIO = "Hudba, audio";
export const BZ2_CAT_ADULTS_BAGS_BETLS_WALLETS = "M\u00f3dne doplnky";
export const BZ2_CAT_ADULTS_BLOUSE_SHIRTS = "Bl\u00fazky, ko\u0161ele";
export const BZ2_CAT_ADULTS_BOOKS = "Knihy pre dospel\u00fdch";
export const BZ2_CAT_ADULTS_BOOKS_AUDIO_VIDEO = "Knihy pre dospel\u00fdch";
export const BZ2_CAT_ADULTS_BOOKS_MAGAZINES_AUDIO_VIDEO = "O rodi\u010dovstve";
export const BZ2_CAT_ADULTS_CLOTHING_MEGAPACKS = "Bal\u00edky oble\u010denia";
export const BZ2_CAT_ADULTS_COATS = "Kab\u00e1ty a sak\u00e1";
export const BZ2_CAT_ADULTS_DRESSES = "\u0160aty";
export const BZ2_CAT_ADULTS_FANCY_DRESS = "Oble\u010denie a doplnky na karneval";
export const BZ2_CAT_ADULTS_FOOTWEAR = "Obuv";
export const BZ2_CAT_ADULTS_HANDICRAFTS = "Ru\u010dn\u00e9 pr\u00e1ce (nie v\u00fdrobky)";
export const BZ2_CAT_ADULTS_HATS_GLOVES = "\u010ciapky, rukavice, \u0161\u00e1ly ";
export const BZ2_CAT_ADULTS_HEALTH_BEAUTY = "Kozmetika a hygiena";
export const BZ2_CAT_ADULTS_HOMEWARE = "In\u00e9 do dom\u00e1cnosti";
export const BZ2_CAT_ADULTS_JACKETS = "Bundy, vetrovky";
export const BZ2_CAT_ADULTS_JEWELLERY = "\u0160perky bi\u017eu hodinky";
export const BZ2_CAT_ADULTS_MAGAZINES = "\u010casopisy";
export const BZ2_CAT_ADULTS_MISC = "In\u00e9 pre dospel\u00fdch";
export const BZ2_CAT_ADULTS_MULTIMEDIA = "Knihy, hudba a film pre dospel\u00fdch";
export const BZ2_CAT_ADULTS_OUTFITS = "Komplety a s\u00fapravy";
export const BZ2_CAT_ADULTS_SHORTS = "\u0160ortky, tri\u0161tvr\u0165\u00e1ky";
export const BZ2_CAT_ADULTS_SKIRTS = "Sukne";
export const BZ2_CAT_ADULTS_SLEEPWEAR = "Py\u017eam\u00e1, no\u010dn\u00e9 ko\u0161ele, \u017eupany";
export const BZ2_CAT_ADULTS_SOCKS_TIGHTS = "Pan\u010du\u0161ky, pono\u017eky, \u0161tucne";
export const BZ2_CAT_ADULTS_SPORT = "\u0160portov\u00e9 potreby pre dospel\u00fdch";
export const BZ2_CAT_ADULTS_SPORT_CLOTHING = "Oble\u010denie na \u0161port, dresy";
export const BZ2_CAT_ADULTS_SUITS = "Obleky a kost\u00fdmy";
export const BZ2_CAT_ADULTS_SWEATSHIRTS_KNITWEAR = "Mikiny, svetre, vesty";
export const BZ2_CAT_ADULTS_SWIMWEAR = "Plavky";
export const BZ2_CAT_ADULTS_TRAUSERS_JEANS = "Nohavice, rifle, tepl\u00e1ky";
export const BZ2_CAT_ADULTS_TSHIRTS_TOPS = "Tri\u010dk\u00e1 a tielka (nie spodn\u00e1 bielize\u0148)";
export const BZ2_CAT_ADULTS_UNDERWEAR = "Spodn\u00e1 bielize\u0148";
export const BZ2_CAT_ADULTS_VIDEO = "Filmy a video";
export const BZ2_CAT_BABY_ACCESSORIES = "M\u00f3dne doplnky";
export const BZ2_CAT_BABY_CARRIERS = "\u0160atky, nosi\u010de, klokanky";
export const BZ2_CAT_BABY_FEEDING = "Potreby pre doj\u010dat\u00e1";
export const BZ2_CAT_BABY_MISC = "In\u00e9 detsk\u00e9";
export const BZ2_CAT_BIRTH = "Pom\u00f4cky pre p\u00f4rod a \u0161estonedelie";
export const BZ2_CAT_BLANKETS_WRAPPERS = "Deky, zavinova\u010dky";
export const BZ2_CAT_BLOUSE_SHIRTS = "Ko\u0161ele, bl\u00fazky";
export const BZ2_CAT_BODYSUITS_SLEEPSUITS_ROMPERS = "Body, dupa\u010dky, overaly";
export const BZ2_CAT_BOOKS_AUDIO_VIDEO = "Kni\u017eky rozpr\u00e1vky pesni\u010dky";
export const BZ2_CAT_BOUNCERS = "Leh\u00e1tka a hacky pre b\u00e1b\u00e4tko";
export const BZ2_CAT_BREASTFEEDING_ACCESSORIES = "Potreby pre doj\u010diace matky";
export const BZ2_CAT_CAMERA_PHOTO_VIDEO = "Fotoapar\u00e1ty a videokamery";
export const BZ2_CAT_CAR_SEATS = "Autoseda\u010dky";
export const BZ2_CAT_CELEBRATIONS = "Karneval sviatky oslavy ";
export const BZ2_CAT_CHILDREN_AUDIO = "Hudba a audio pre deti";
export const BZ2_CAT_CHILDREN_BOOKS = "Detsk\u00e9 knihy";
export const BZ2_CAT_CHILDREN_CARE = "Starostlivos\u0165 o deti";
export const BZ2_CAT_CHILDREN_CLOTHING = "Oble\u010denie detsk\u00e9";
export const BZ2_CAT_CHILDREN_MAGAZINES = "Detsk\u00e9 \u010dasopisy";
export const BZ2_CAT_CHILDREN_MULTIMEDIA = "Knihy, hudba a film pre deti";
export const BZ2_CAT_CHILDREN_VIDEO = "Filmy a video pre deti";
export const BZ2_CAT_CHRISTMAS = "Viano\u010dn\u00e9 dekor\u00e1cie";
export const BZ2_CAT_CLOTHING_MEGAPACKS = "Bal\u00edky / mix oble\u010denia";
export const BZ2_CAT_COSMETICS_BATHING = "K\u00fapanie, preba\u013eovanie a hygiena";
export const BZ2_CAT_COTS = "Postele, ohr\u00e1dky";
export const BZ2_CAT_DINING = "Jed\u00e1lensk\u00e9 stoli\u010dky a potreby";
export const BZ2_CAT_DRESSES_SKIRTS = "Sukni\u010dky, \u0161ati\u010dky";
export const BZ2_CAT_EARLY_BABIES = "Pred\u010dasniatka";
export const BZ2_CAT_EASTER = "Ve\u013ek\u00e1 noc";
export const BZ2_CAT_ELECTRONICS = "Mobily, foto, elektronika";
export const BZ2_CAT_FACE_PAINTING = "Ma\u013eovanie na tv\u00e1r";
export const BZ2_CAT_FANCY_DRESS = "Karnevalov\u00e9 kost\u00fdmy (deti)";
export const BZ2_CAT_FANCY_DRESS_ACCESSORIES = "Doplnky na karneval (deti)";
export const BZ2_CAT_FOOD = "Dom\u00e1ce a zdrav\u00e9 potraviny";
export const BZ2_CAT_FOOTWEAR = "Obuv detsk\u00e1";
export const BZ2_CAT_GIFTS = "Dar\u010dekov\u00e9 a spomienkov\u00e9 predmety";
export const BZ2_CAT_HATS_MITTENS_SCARVES = "\u010ciapky, rukavice, \u0161\u00e1ly";
export const BZ2_CAT_HOME_ACCESSORIES_DECORATIONS = "Bytov\u00e9 doplnky a dekor\u00e1cie";
export const BZ2_CAT_HOME_ANTIQUITIES = "Staro\u017eitnosti";
export const BZ2_CAT_HOME_APPLIANCES = "Spotrebi\u010de do dom\u00e1cnosti";
export const BZ2_CAT_HOME_CARE_CLEANING = "Drog\u00e9ria, upratovanie a \u017eehlenie";
export const BZ2_CAT_HOME_CARPETS_RUGS = "Koberce a roho\u017eky";
export const BZ2_CAT_HOME_COOKING_BAKING_WARE = "Varenie, pe\u010denie";
export const BZ2_CAT_HOME_DINING = "Stolovanie";
export const BZ2_CAT_HOME_FOOD_STORAGE = "Skladovanie a preprava potrav\u00edn";
export const BZ2_CAT_HOME_FURNITURE = "N\u00e1bytok";
export const BZ2_CAT_HOME_LIGHTING = "Lampy a osvetlenie";
export const BZ2_CAT_HOME_LIVING = "Dom\u00e1cnos\u0165";
export const BZ2_CAT_HOME_TEXTILES = "Text\u00edlie";
export const BZ2_CAT_JACKETS_COATS = "Bundy, vetrovky, kab\u00e1ty";
export const BZ2_CAT_KIDS_PARTY = "Detsk\u00e1 oslava";
export const BZ2_CAT_KINDERGARDEN_SCHOOL = "\u0160k\u00f4lk\u00e1ri a \u0161kol\u00e1ci";
export const BZ2_CAT_MISC = "In\u00e9";
export const BZ2_CAT_MISC_MOTHERHOOD = "Pom\u00f4cky pre tehotenstvo";
export const BZ2_CAT_MOTHER_CLOTHING = "Oble\u010denie obuv dospel\u00ed";
export const BZ2_CAT_MOTHERS_NOURISHMENT = "V\u00fd\u017eivov\u00e9 doplnky pre tehotn\u00e9 a mami\u010dky";
export const BZ2_CAT_NAPPIES = "Plienky";
export const BZ2_CAT_NOURISHMENT = "Detsk\u00e1 v\u00fd\u017eiva, potravinov\u00e9 doplnky";
export const BZ2_CAT_NURSERY = "Detsk\u00e1 izba";
export const BZ2_CAT_NURSING_BRA = "Podprsenky na doj\u010denie";
export const BZ2_CAT_OCCASION_WEAR = "Sl\u00e1vnostn\u00e9 a viano\u010dn\u00e9 oble\u010denie";
export const BZ2_CAT_OTHER_ELECTRONICS = "In\u00e1 elektronika";
export const BZ2_CAT_OUTFITS = "Komplety, s\u00fapravy (nie zimn\u00e9)";
export const BZ2_CAT_PARTY_CARNEVAL = "Oslava, p\u00e1rty, karneval";
export const BZ2_CAT_PC_GAMING = "Hern\u00e9 konzoly a hry";
export const BZ2_CAT_PC_NOTEBOOKS = "Notebooky a po\u010d\u00edta\u010de";
export const BZ2_CAT_PETS = "Dom\u00e1ce zvieratk\u00e1";
export const BZ2_CAT_PHONES_TABLETS_EREADERS = "Mobily, tablety a \u010d\u00edta\u010dky kn\u00edh";
export const BZ2_CAT_PRAMS = "Ko\u010d\u00edky a fusaky";
export const BZ2_CAT_PREGNANCY_CLOTHING = "Oble\u010denie pre tehotn\u00e9";
export const BZ2_CAT_PREGNANCY_MOTHERS = "Tehotenstvo doj\u010denie";
export const BZ2_CAT_SAFETY = "Monitory dychu, pest\u00fanky a bezpe\u010dnos\u0165";
export const BZ2_CAT_SEO_BABY_ACCESSORIES = "Detsk\u00e9 m\u00f3dne doplnky";
export const BZ2_CAT_SEO_BLOUSE_SHIRTS = "Detsk\u00e9 ko\u0161ele, bl\u00fazky";
export const BZ2_CAT_SEO_BODYSUITS_SLEEPSUITS_ROMPERS = "Detsk\u00e9 body, dupa\u010dky, overaly";
export const BZ2_CAT_SEO_CLOTHING_MEGAPACKS = "Bal\u00edky / mix oble\u010denia pre deti";
export const BZ2_CAT_SEO_DRESSES_SKIRTS = "Detsk\u00e9 sukni\u010dky, \u0161ati\u010dky";
export const BZ2_CAT_SEO_HATS_MITTENS_SCARVES = "Detsk\u00e9 \u010diapky, rukavice, \u0161\u00e1ly";
export const BZ2_CAT_SEO_JACKETS_COATS = "Detsk\u00e9 bundy, vetrovky, kab\u00e1ty";
export const BZ2_CAT_SEO_OCCASION_WEAR = "Detsk\u00e9 sl\u00e1vnostn\u00e9 a viano\u010dn\u00e9 oble\u010denie";
export const BZ2_CAT_SEO_OUTFITS = "Detsk\u00e9 komplety, s\u00fapravy";
export const BZ2_CAT_SEO_SHORTS_CROPS = "Detsk\u00e9 \u0161ortky, tri\u0161tvr\u0165\u00e1ky";
export const BZ2_CAT_SEO_SLEEPING_BAGS = "Detsk\u00e9 spacie vaky";
export const BZ2_CAT_SEO_SLEEPWEAR = "Detsk\u00e9 py\u017eam\u00e1 a no\u010dn\u00e9 ko\u0161ele";
export const BZ2_CAT_SEO_SNOWSUITS = "Detsk\u00e9 zimn\u00e9 kombin\u00e9zy a otep\u013eova\u010dky";
export const BZ2_CAT_SEO_SOCKS_TIGHTS = "Detsk\u00e9 pan\u010du\u0161ky, pono\u017eky, \u0161tucne";
export const BZ2_CAT_SEO_SWEATSHIRTS_JUMPERS_VESTS = "Detsk\u00e9 mikiny, svetre, bolerk\u00e1";
export const BZ2_CAT_SEO_SWIMWEAR_DRESSING_GOWNS = "Detsk\u00e9 plavky, \u017eupany";
export const BZ2_CAT_SEO_TROUSERS_JEANS_JOGGERS = "Detsk\u00e9 nohavice, rifle, tepl\u00e1ky";
export const BZ2_CAT_SEO_TSHIRTS_TOPS = "Detsk\u00e9 tri\u010dk\u00e1, tielka";
export const BZ2_CAT_SEO_TWINS = "Oble\u010denie a obuv pre dvoji\u010dky";
export const BZ2_CAT_SEO_TWINS_MISC = "R\u00f4zne (ko\u010d\u00edky, seda\u010dky, potreby) pre dvoji\u010dky";
export const BZ2_CAT_SEO_UNDERWEAR = "Detsk\u00e1 spodn\u00e1 bielize\u0148";
export const BZ2_CAT_SHORTS_CROPS = "\u0160ortky, tri\u0161tvr\u0165\u00e1ky";
export const BZ2_CAT_SLEEPING_BAGS = "Spacie vaky";
export const BZ2_CAT_SLEEPWEAR = "Py\u017eam\u00e1 a no\u010dn\u00e9 ko\u0161ele";
export const BZ2_CAT_SNOWSUITS = "Zimn\u00e9 kombin\u00e9zy a otep\u013eova\u010dky";
export const BZ2_CAT_SOCKS_TIGHTS = "Pan\u010du\u0161ky, pono\u017eky, \u0161tucne";
export const BZ2_CAT_SPORT = "\u0160port pre deti";
export const BZ2_CAT_SWEATSHIRTS_JUMPERS_VESTS = "Mikiny, svetre, bolerk\u00e1";
export const BZ2_CAT_SWIMWEAR_DRESSING_GOWNS = "Plavky, \u017eupany";
export const BZ2_CAT_TOYS = "Hra\u010dky a hry";
export const BZ2_CAT_TROUSERS_JEANS_JOGGERS = "Nohavice, rifle, tepl\u00e1ky";
export const BZ2_CAT_TSHIRTS_TOPS = "Tri\u010dk\u00e1, tielka (nie spodn\u00e1 bielize\u0148)";
export const BZ2_CAT_TWINS = "Oble\u010denie a obuv";
export const BZ2_CAT_TWINS_GROUP = "Dvoji\u010dky";
export const BZ2_CAT_TWINS_MISC = "R\u00f4zne (ko\u010d\u00edky, seda\u010dky, potreby) ";
export const BZ2_CAT_UNDERWEAR = "Spodn\u00e1 bielize\u0148";
export const BZ2_CAT_WALKERS = "Na koles\u00e1ch";
export const BZ2_FACET_CATEGORY = "Kateg\u00f3ria";
export const BZ2_FACET_CATS = "Kateg\u00f3ria";
export const BZ2_FACET_GROUPS = "Moje skupiny";
export const BZ2_FACET_LOCATIONS = "Lokalita";
export const BZ2_FACET_P_AGE_GROUP = "Vek";
export const BZ2_FACET_P_AGE_MONTHS = "Ve\u013ekost (vek)";
export const BZ2_FACET_P_AGE_YEARS = "Vek";
export const BZ2_FACET_P_ANIMAL = "Zvieratko";
export const BZ2_FACET_P_BRACES = "Traky";
export const BZ2_FACET_P_BRAND = "Zna\u010dka";
export const BZ2_FACET_P_COLOR = "K\u013e\u00fa\u010dov\u00e1 farba";
export const BZ2_FACET_P_CUP_SIZE = "Ko\u0161\u00edk";
export const BZ2_FACET_P_DATA_CARRIER = "Nosi\u010d";
export const BZ2_FACET_P_GAMING_PLATFORM = "Hern\u00e1 platforma";
export const BZ2_FACET_P_LANGUAGE = "Jazyk";
export const BZ2_FACET_P_LENGTH = "D\u013a\u017eka";
export const BZ2_FACET_P_LENGTH_ORDINAL = "D\u013a\u017eka (cm)";
export const BZ2_FACET_P_MATERIAL = "Materi\u00e1l";
export const BZ2_FACET_P_NECKLINE = "V\u00fdstrih";
export const BZ2_FACET_P_OCCASION = "Pr\u00edle\u017eitos\u0165";
export const BZ2_FACET_P_PRICE = "Cena v EUR";
export const BZ2_FACET_P_QUALITY = "Kvalita";
export const BZ2_FACET_P_SCREEN_SIZE = "Uhloprie\u010dka";
export const BZ2_FACET_P_SEASON = "Ro\u010dn\u00e9 obdobie";
export const BZ2_FACET_P_SEX = "Pre koho";
export const BZ2_FACET_P_SEX_TWIN = "Pohlavie";
export const BZ2_FACET_P_SHAPE = "Strih";
export const BZ2_FACET_P_SIZE = "Ve\u013ekos\u0165";
export const BZ2_FACET_P_SIZE_INTERVAL = "Ve\u013ekos\u0165";
export const BZ2_FACET_P_SIZE_WEIGHT = "Ve\u013ekos\u0165";
export const BZ2_FACET_P_SLEEVE = "Ruk\u00e1v";
export const BZ2_FACET_P_STYLE = "\u0160t\u00fdl";
export const BZ2_FACET_P_SUBJECT = "\u017d\u00e1ner";
export const BZ2_FACET_P_THEMA = "T\u00e9ma";
export const BZ2_FACET_P_TYPE = "Typ";
export const BZ2_FACET_P_USAGE = "Pou\u017eitie";
export const BZ2_FACET_P_WIDTH_ORDINAL = "\u0160\u00edrka (cm)";
export const BZ2_FACET_QUALITY = "Pou\u017eit\u00fd tovar / Vlastn\u00e1 v\u00fdroba / Nov\u00fd tovar";
export const BZ2_FACET_SCREEN_SIZE = "Uhloprie\u010dka";
export const BZ2_HANDMADE_PRODUCT_HOVER = "Vlastn\u00e1 v\u00fdroba";
export const BZ2_NEW_PRODUCT_HOVER = "Nov\u00fd tovar";
export const BZ2_OLD_PRODUCT_HOVER = "Pou\u017eit\u00fd tovar";
export const BZ2_SORT_COMPLAINTS = "Najviac nahl\u00e1sen\u00e9";
export const BZ2_SORT_COMPLAINTS_ASC = "Najmenej nahl\u00e1sen\u00e9";
export const BZ2_SORT_COMPLAINT_TIME = "Nahl\u00e1sen\u00e9: ned\u00e1vno";
export const BZ2_SORT_COMPLAINT_TIME_ASC = "Nahl\u00e1sen\u00e9: d\u00e1vno";
export const BZ2_SORT_LEAST_RECENT_ADDED = "Pridan\u00e9: D\u00e1vno";
export const BZ2_SORT_LEAST_RECENT_UPDATED = "Aktualizovan\u00e9: D\u00e1vno";
export const BZ2_SORT_PRICE = "Cena: Od najlacnej\u0161\u00edch";
export const BZ2_SORT_PRICE_DESC = "Cena: Od najdrah\u0161\u00edch";
export const BZ2_SORT_RECENT_ADDED = "Pridan\u00e9: Ned\u00e1vno";
export const BZ2_SORT_RECENT_UPDATED = "Aktualizovan\u00e9: Ned\u00e1vno";
export const BZ2_SORT_SCORE_NEW = "Relevantn\u00e9";
export const BZ2_SORT_WISHLIST_ADDED_ASC = "Ulo\u017een\u00e9: d\u00e1vno";
export const BZ2_SORT_WISHLIST_ADDED_DESC = "Ulo\u017een\u00e9: ned\u00e1vno";
export const PRODUCT_FILTER_ACTUALIZABLE = "Daj\u00fa sa aktualizova\u0165";
export const PRODUCT_FILTER_ALL = "V\u0161etko (okrem zmazan\u00fdch)";
export const PRODUCT_FILTER_DELETED = "Zmazan\u00e9";
export const PRODUCT_FILTER_DISPLAYING = "Zobrazuj\u00fa sa";
export const PRODUCT_FILTER_EXPIRED = "Exspirovan\u00e9 (28 dn\u00ed +)";
export const PRODUCT_FILTER_NONDISPLAYING = "Nezobrazuj\u00fa sa";
export const PRODUCT_FILTER_NOTANSWERED = "Kde som neodpovedala";
